<template>
  <!-- <div class="panel-top">
    <div class="lang-selector-holder d-flex align-items-center">
      <label class="custom-label">Переклад на</label>
    </div>
  </div> -->
  <div class="panel-middle">
    <div class="review-top-name-holder d-flex align-items-center justify-content-between mb-2">
      <h3 class="panel-top-name">{{ $static('review-editor.edit-title', 'Редагування відгуку №') }}<span>{{
        editedReview.id }}</span></h3>
      <div class="form-group">
        <div class="d-flex">
          <div class="option-line mt-0">
            <div class="custom-label mb-0" style="margin-right: 20px;">{{ $static('review-editor.is-shown',
              'Відображення на сайті') }}</div>
            <div class="toggler r" @click.stop="editReviewVisibility()">
              <input type="checkbox" class="toggle-check" v-model="editedReview.active">
              <div class="knobs"></div>
              <div class="layer"></div>
            </div>
          </div>
          <div class="available in_stock" style="margin-left: 40px;"><span>{{ showReviewVisibility() }}</span></div>
        </div>
      </div>
    </div>
    <div class="review-container">
      <div class="review-chain-section">
        <div class="review-block">
          <div class="review-block__header">
            <div class="review-block__header-part-wrapper left">
              <div class="review-block__avatar">
                <img v-if="selectedReviewForEdit.body.reviewAuthorAvatar"
                  :src="selectedReviewForEdit.body.reviewAuthorAvatar" :alt="selectedReviewForEdit?.body?.name">
                <span v-else>{{ reviewAuthorName[0] }}</span>
              </div>
              <div class="review-block__username-wrapper">
                <h3 class="review-block__username">{{ reviewAuthorName }}</h3>
                <p class="review-block__status">{{ $static('review-editor.status', 'вже купив(ла)') }}</p>
              </div>
            </div>
            <div class="review-block__header-part-wrapper right">
              <div class="review-block__date">
                <input class="form-control custom-input" type="datetime-local" :value="getReviewTime()"
                  @input="setReviewTime($event)">
              </div>
              <div class="review-block__date-raiting-divider"></div>
              <div class="raiting-container in-review-block">
                <svg width="22" height="18" viewBox="0 0 22 18" class="raiting-star in-review-block"
                  style="cursor: pointer" v-for="(starPosition, modalStarIndex) in 5" :key="modalStarIndex"
                  @click="setRating(modalStarIndex)" @mouseenter="vRate = modalStarIndex + 1" @mouseleave="vRate = 0"
                  :class="{ 'filled': virtualRating >= modalStarIndex + 1 }" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M17.497 17.9939L17.4335 17.498C17.3881 17.5038 17.3455 17.4967 17.3134 17.4829L17.3091 17.481L11.4778 15.0301C11.1747 14.9026 10.8253 14.9026 10.5221 15.0301L4.69089 17.481L4.68824 17.4822C4.64016 17.5027 4.58244 17.5055 4.53089 17.4905C4.47868 17.4752 4.45787 17.45 4.45269 17.4409C4.45229 17.4402 4.45197 17.4396 4.45171 17.4391L5.36731 11.9419C5.36734 11.9417 5.36738 11.9415 5.36742 11.9413C5.42771 11.5825 5.28507 11.2408 5.02724 11.0132L0.517289 7.0277L0.517294 7.02769L0.515239 7.02589C0.50745 7.01909 0.503388 7.01379 0.501409 7.01072C0.503461 7.00751 0.507863 7.00175 0.516599 6.99435L0.517376 6.99368C0.53532 6.97841 0.567874 6.96116 0.611961 6.95476L0.611962 6.95476L0.613903 6.95447L7.0019 6.00104C7.00205 6.00102 7.0022 6.001 7.00235 6.00098C7.32715 5.95307 7.63633 5.77376 7.81691 5.47975C7.81704 5.47954 7.81717 5.47933 7.8173 5.47912L10.8529 0.561154L10.8529 0.561159L10.8544 0.558618C10.8609 0.548031 10.884 0.52248 10.9375 0.508157C10.9903 0.494025 11.0477 0.498449 11.0943 0.519662L11.0951 0.520027C11.1277 0.534791 11.1414 0.551896 11.1454 0.558467L11.1454 0.558472L11.1471 0.561154L14.1827 5.47912C14.1827 5.47927 14.1828 5.47942 14.1829 5.47957C14.3635 5.7737 14.6728 5.95307 14.9977 6.00098C14.9978 6.001 14.9979 6.00102 14.9981 6.00104L21.3861 6.95448L21.3886 6.95484C21.4491 6.96356 21.4818 6.98981 21.4941 7.00475C21.4961 7.00709 21.4975 7.00906 21.4984 7.01062C21.4963 7.01403 21.4922 7.01938 21.4845 7.02605L21.4827 7.0277L16.9727 11.0132C16.9726 11.0133 16.9726 11.0133 16.9725 11.0134C16.7148 11.241 16.5723 11.5826 16.6325 11.9412C16.6326 11.9414 16.6326 11.9417 16.6326 11.9419L17.5483 17.4397C17.5473 17.4416 17.5454 17.4444 17.5422 17.4482C17.5288 17.4639 17.4944 17.4901 17.4329 17.498L17.497 17.9939Z"
                    stroke="#FFC828" fill="none" />
                </svg>
              </div>

              <!--              <div class="raiting-container in-review-block">-->
              <!--                <svg data-modal-review-raiting width="22" height="18" viewBox="0 0 22 18" class="raiting-star unfilled in-modal"-->
              <!--                     xmlns="http://www.w3.org/2000/svg"-->
              <!--                     v-for="(starPosition, modalStarIndex) in 5" :key="modalStarIndex" @click="setRating(modalStarIndex)"-->
              <!--                     @mouseenter="vRate = modalStarIndex" @mouseleave="vRate=0"-->
              <!--                     :class="{'filled': virtualRating >= modalStarIndex}">-->
              <!--                  <path-->
              <!--                      d="M17.497 17.9939L17.4335 17.498C17.3881 17.5038 17.3455 17.4967 17.3134 17.4829L17.3091 17.481L11.4778 15.0301C11.1747 14.9026 10.8253 14.9026 10.5221 15.0301L4.69089 17.481L4.68824 17.4822C4.64016 17.5027 4.58244 17.5055 4.53089 17.4905C4.47868 17.4752 4.45787 17.45 4.45269 17.4409C4.45229 17.4402 4.45197 17.4396 4.45171 17.4391L5.36731 11.9419C5.36734 11.9417 5.36738 11.9415 5.36742 11.9413C5.42771 11.5825 5.28507 11.2408 5.02724 11.0132L0.517289 7.0277L0.517294 7.02769L0.515239 7.02589C0.50745 7.01909 0.503388 7.01379 0.501409 7.01072C0.503461 7.00751 0.507863 7.00175 0.516599 6.99435L0.517376 6.99368C0.53532 6.97841 0.567874 6.96116 0.611961 6.95476L0.611962 6.95476L0.613903 6.95447L7.0019 6.00104C7.00205 6.00102 7.0022 6.001 7.00235 6.00098C7.32715 5.95307 7.63633 5.77376 7.81691 5.47975C7.81704 5.47954 7.81717 5.47933 7.8173 5.47912L10.8529 0.561154L10.8529 0.561159L10.8544 0.558618C10.8609 0.548031 10.884 0.52248 10.9375 0.508157C10.9903 0.494025 11.0477 0.498449 11.0943 0.519662L11.0951 0.520027C11.1277 0.534791 11.1414 0.551896 11.1454 0.558467L11.1454 0.558472L11.1471 0.561154L14.1827 5.47912C14.1827 5.47927 14.1828 5.47942 14.1829 5.47957C14.3635 5.7737 14.6728 5.95307 14.9977 6.00098C14.9978 6.001 14.9979 6.00102 14.9981 6.00104L21.3861 6.95448L21.3886 6.95484C21.4491 6.96356 21.4818 6.98981 21.4941 7.00475C21.4961 7.00709 21.4975 7.00906 21.4984 7.01062C21.4963 7.01403 21.4922 7.01938 21.4845 7.02605L21.4827 7.0277L16.9727 11.0132C16.9726 11.0133 16.9726 11.0133 16.9725 11.0134C16.7148 11.241 16.5723 11.5826 16.6325 11.9412C16.6326 11.9414 16.6326 11.9417 16.6326 11.9419L17.5483 17.4397C17.5473 17.4416 17.5454 17.4444 17.5422 17.4482C17.5288 17.4639 17.4944 17.4901 17.4329 17.498L17.497 17.9939Z"-->
              <!--                      stroke="#FFC828"/>-->
              <!--                </svg>-->
              <!--              </div>-->

            </div>
          </div>

          <div class="review-block__main-content">
            <div class="review-block__text">
              <textarea class="form-control custom-input" :value="getReviewComment()"
                @input="editReviewComment($event)"></textarea>
            </div>
            <div class="review-block__tag-container">
              <div class="review-block__tag">
                <div class="form-group">
                  <div class="custom-label">{{ $static('review-editor.tags ', 'Теги') }}</div>
                  <div class="size-checkbox-group">
                    <!--size checkbox-->
                    <div class="option-checkbox" v-for="(reviewTag, reviewTagIndex) in tags" key="reviewTagIndex">
                      <input :id="reviewTag + reviewTagIndex" type="checkbox" :checked="isReviewTagChecked(reviewTag)"
                        @change="handleReviewTagClick(reviewTag)">
                      <label :for="reviewTag + reviewTagIndex">{{ reviewTag.toLowerCase().trim() }}</label>
                    </div>
                    <!--end size checkbox-->
                  </div>
                </div>
              </div>
            </div>
            <div class="review-block__photo-container">
              <div class="files-uploader default-files-uploader">
                <div class="uploader-previews" :style="{ paddingLeft: '10px' }">
                  <template v-if="editedReview.body?.photo?.length > 0">
                    <div class="image bg" v-for="(reviewPhoto, reviewPhotoIndex) in editedReview.body?.photo"
                      :key="reviewPhotoIndex" :style="{ backgroundImage: $filters.backgroundImage(reviewPhoto) }">
                      <Popper arrow content="Збiльшити" hover placement="top" style="white-space: nowrap">
                        <a data-fancybox="gallery" class="btn-icon btn-remove btn-small" :href="reviewPhoto"
                          style="bottom: 3px;top: inherit;left: 3px;"><span
                            class="icon icon-right icon-trash-unfilled"></span></a>
                      </Popper>
                      <Popper arrow content="Видалити" hover placement="top" style="white-space: nowrap">
                        <button class="btn-icon btn-remove btn-small" style="bottom: 3px;top: inherit;right: 3px;">
                          <span class="icon icon-right icon-trash-filled"></span>
                        </button>
                      </Popper>
                    </div>
                  </template>
                  <template v-else>
                    <p>{{ $static('review-editor.no-photos ', 'Фотографії відсутні') }}</p>
                  </template>
                </div>
              </div>
            </div>
            <div class="review-block__answers-counter">
              <button class="transparent-btn default-btn" @click="addReviewAnswer"
                :disabled="hasAnswer || showAnswerField">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M4.59187 15.3042C2.344 9.78675 6.40311 3.75 12.3609 3.75H12.6823C17.138 3.75 20.75 7.36201 20.75 11.8176C20.75 16.7785 16.7284 20.8 11.7676 20.8H3.94735C3.6291 20.8 3.34549 20.5991 3.23987 20.2989C3.13424 19.9987 3.22959 19.6645 3.47773 19.4652L5.44922 17.8819C5.53543 17.8127 5.56592 17.6951 5.5242 17.5927L4.59187 15.3042ZM12.3609 5.25C7.46839 5.25 4.13507 10.2074 5.98101 14.7383L6.91334 17.0268C7.20534 17.7435 6.99189 18.5669 6.38847 19.0515L6.07902 19.3H11.7676C15.9 19.3 19.25 15.95 19.25 11.8176C19.25 8.19044 16.3096 5.25 12.6823 5.25H12.3609Z"
                    fill="black" />
                </svg>
                <span class="text">{{ $static('review-editor.answer ', 'Відповісти') }}</span>
              </button>

            </div>
          </div>
        </div>
        <div class="review-block__answers-container" v-if="hasAnswer || showAnswerField">
          <div class="review-block review-block--answer">
            <div class="review-block__header">
              <div class="review-block__header-part-wrapper left">
                <div class="review-block__avatar">
                  <img src="/images/logo-dark.svg" alt="uxlove studio">
                  <!--                  <img v-if="isReviewAnswerAvatar" :src="this.$store.getters.getSettings?.logo" alt="аватар">-->
                  <!--                    <span >М</span>-->

                </div>
                <div class="review-block__username-wrapper">
                  <h3 class="review-block__username">{{ $static('review.username', 'Менеджер') }}</h3>
                  <p class="review-block__status">{{ $static('review.user-status', 'отдел контроля качества') }} </p>
                </div>
              </div>
              <div class="review-block__header-part-wrapper right">
                <div class="review-block__date">
                  <input class="form-control custom-input" type="datetime-local" :value="getReviewAnswerTime()"
                    :min="getReviewTime()" @input="setReviewAnswerTime($event)">
                </div>

              </div>
            </div>

            <div class="review-block__main-content">
              <div class="review-block__text">
                <textarea ref="answerArea" class="form-control custom-input" :value="getReviewAnswer()"
                  @input="editReviewAnswer($event)"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--        <div class="row">-->
    <!--            <div class="col">-->
    <!--                <div class="form-group">-->
    <!--                    <div class="custom-label">Користувач</div>-->
    <!--                    <input type="text" class="form-control custom-input" :value="getReviewAvtorName()"-->
    <!--                        @input="editReviewAvtorName($event)">-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--        <div class="row">-->
    <!--            <div class="col">-->
    <!--                <div class="form-group">-->
    <!--                    <div class="custom-label">Рейтинг</div>-->
    <!--                    <input type="text" class="form-control custom-input" :value="editedReview?.body?.reviewRaiting || '-'"-->
    <!--                        disabled>-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--        <div class="row">-->
    <!--            <div class="col">-->
    <!--                <div class="form-group">-->
    <!--                    <div class="custom-label">Комментар</div>-->
    <!--                    <textarea class="form-control custom-input" :value="getReviewComment()"-->
    <!--                        @input="editReviewComment($event)"></textarea>-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->

    <!--        <div class="row">-->
    <!--            <div class="col">-->
    <!--                <div class="form-group">-->
    <!--                    <div class="custom-label">Теги</div>-->
    <!--                    <div class="size-checkbox-group">-->
    <!--                        &lt;!&ndash;size checkbox&ndash;&gt;-->
    <!--                        <div class="option-checkbox" v-for="(reviewTag, reviewTagIndex) in tags" key="reviewTagIndex">-->
    <!--                            <input :id="reviewTag + reviewTagIndex" type="checkbox" :checked="isReviewTagChecked(reviewTag)"-->
    <!--                                @change="handleReviewTagClick(reviewTag)">-->
    <!--                            <label :for="reviewTag + reviewTagIndex">{{ reviewTag.toLowerCase().trim() }}</label>-->
    <!--                        </div>-->
    <!--                        &lt;!&ndash;end size checkbox&ndash;&gt;-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->

    <!--        <div class="row">-->
    <!--            <div class="col">-->
    <!--                <div class="form-group">-->
    <!--                    <div class="custom-label">Фотографії</div>-->
    <!--                    <div class="files-uploader default-files-uploader">-->
    <!--                        <div class="uploader-previews" :style="{ paddingLeft: '10px' }">-->
    <!--                            <template v-if="editedReview.body?.photo?.length > 0">-->
    <!--                                <div class="image bg" v-for="(reviewPhoto, reviewPhotoIndex) in editedReview.body?.photo"-->
    <!--                                    :key="reviewPhotoIndex" :style="{ backgroundImage: `url(${reviewPhoto})` }">-->
    <!--                                </div>-->
    <!--                            </template>-->
    <!--                            <template v-else>-->
    <!--                                <p>Фотографії відсутні</p>-->
    <!--                            </template>-->
    <!--                        </div>-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->


    <!--        <div class="row">-->
    <!--            <div class="col-4">-->
    <!--                <div class="form-group">-->
    <!--                    <div class="custom-label">Час</div>-->
    <!--                    <input class="form-control custom-input" type="datetime-local" :value="getReviewTime()" @input="setReviewTime($event)">-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--        <h3 class="panel-top-name">Відповісти</h3>-->
    <!--        <div class="row">-->
    <!--            <div class="col">-->
    <!--                <div class="form-group">-->
    <!--                    <textarea class="form-control custom-input" :value="getReviewAnswer()"-->
    <!--                        @input="editReviewAnswer($event)"></textarea>-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--        <div class="row">-->
    <!--            <div class="col-4">-->
    <!--                <div class="form-group">-->
    <!--                    <div class="custom-label">Час</div>-->
    <!--                    <input  class="form-control custom-input"  type="datetime-local" :value="getReviewAnswerTime()" :min="getReviewTime()"-->
    <!--                        @input="setReviewAnswerTime($event)">-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->
  </div>
  <div class="panel-bottom">
    <button class="transparent-btn default-btn back_trigger" @click="$emit('closeReviewEditor')">
      <span class="text">{{ $static('ei.cancel', 'Скасувати') }}</span>
    </button>
    <button class="default-btn btn-accent" @click="saveReviewChanges">
      <span class="text">{{ $static('ei.save', 'Зберегти зміни') }}</span>
    </button>
    <button class="default-btn btn-red" v-if="checkedReviewsStatus === 'unmoderated'" @click="$emit('deleteReview')">
      <span class="text">{{ $static('cp.del', 'Видалити') }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ReviewEditor',
  components: {},
  props: {
    selectedReviewForEdit:
    {
      type: Object,
      required: true
    },
    checkedReviewsStatus: {
      type: String,
      required: true
    }
  },
  emits: ['reviewChanged', 'closeReviewEditor', 'deleteReview'],

  data() {
    return {
      editedReview: JSON.parse(JSON.stringify(this.selectedReviewForEdit)),
      vRate: 0,
      showAnswerField: false
    }
  },
  computed: {
    hasAnswer() {
      if (Array.isArray(this.editedReview.body.answers) && this.editedReview.body.answers.length > 0 && this.editedReview.body.answers[0].text.length > 0) {
        return true
      }
      return false
    },
    virtualRating() {
      return this.vRate ? this.vRate : this.editedReview.body.reviewRaiting
    },
    tags() {
      return this.$store.getters.settings?.public?.tags && this.$store.getters.settings?.public?.tags.reviewTags ? this.$dynamic(this.$store.getters.settings.public.tags, this.$store.getters.settings.public.tags.reviewTags, 'reviewTags').split(',') : []
    },
    reviewAuthorName() {
      return this.editedReview?.body?.name || 'Анонім';
    },
  },
  methods: {
    setRating(rate) {
      this.editedReview.body.reviewRaiting = rate + 1
    },
    getReviewAvtorName() {
      // return `${this.editedReview.body.first_name} ${this.editedReview.body.last_name}`
      return this.editedReview.body?.name || '';
    },
    editReviewAvtorName(event) {
      // this.editedReview.body.first_name = event.target.value.split(' ')[0] ?? "";
      // this.editedReview.body.last_name = event.target.value.split(' ').slice(1).join(' ') ?? "";
      this.editedReview.body.name = event.target.value;
    },

    getReviewComment() {
      return this.editedReview.body.comment
    },
    editReviewComment(event) {
      this.editedReview.body.comment = event.target.value;
    },

    showReviewVisibility() {
      if (this.editedReview.active === false) {
        return 'Прихований'
      }

      if (this.editedReview.active === true) {
        return 'Показаний'
      }
    },
    handleReviewTagClick(tag) {
      if (this.isReviewTagChecked(tag)) {
        const tagIdx = this.editedReview.body.tags.findIndex(el => tag.trim().toLowerCase() === el.trim().toLowerCase())
        this.editedReview.body.tags.splice(tagIdx, 1);
      } else {
        this.editedReview.body.tags.push(tag.toLowerCase().trim());
      }
    },
    isReviewTagChecked(tagText) {
      const tagsArray = this.editedReview.body.tags.map(tag => tag.trim());
      tagText = tagText.toLowerCase().trim();

      if (tagsArray.includes(tagText)) {
        return true;
      }

      return false;
    },

    getReviewVisibility() {
      return this.editedReview.active;
    },
    editReviewVisibility() {
      this.editedReview.active = !this.editedReview.active;
    },

    getReviewTime() {
      const formattedDate = new Date(this.editedReview.body?.reviewTime * 1000).toISOString().slice(0, 16);

      if (formattedDate.split('-')[0].length !== 4) {
        return '2000-01-01T00:00'
      }

      return formattedDate;
    },
    setReviewTime(event) {
      const inputTime = new Date(event.target.value);
      const timeOffset = -inputTime.getTimezoneOffset();

      this.editedReview.body.reviewTime = (inputTime.getTime() + timeOffset * 60 * 1000) / 1000;
    },

    getReviewAnswer() {
      this.showAnswerField = true;
      if (Array.isArray(this.editedReview.body.answers) && this.editedReview.body.answers[0] && this.editedReview.body.answers[0]?.text) {
        return this.editedReview.body.answers[0]?.text;
      } else {
        return '';
      }
    },
    editReviewAnswer(event) {
      if (Array.isArray(this.editedReview.body.answers) && this.editedReview.body.answers[0] && this.editedReview.body.answers[0]?.text) {
        this.editedReview.body.answers[0].text = event.target.value;
      } else {
        this.editedReview.body.answers = [{}];
        this.editedReview.body.answers[0].text = event.target.value;
      }

      if (Array.isArray(this.editedReview.body.answers) && this.editedReview.body.answers[0] && this.editedReview.body.answers[0]?.time && this.editedReview.body.answers[0]?.time.length > 0) {
        return;
      }

      this.setReviewAnswerTime();
    },

    getReviewAnswerTime() {
      const currentTime = new Date();
      const timeOffset = -currentTime.getTimezoneOffset();

      if (Array.isArray(this.editedReview.body.answers) && this.editedReview.body.answers[0] && this.editedReview.body.answers[0]?.time) {
        const timeInSeconds = this.editedReview.body.answers[0].time;
        const date = new Date(timeInSeconds * 1000 + timeOffset * 60 * 1000);
        return date.toISOString().slice(0, 16);
      } else {
        return new Date(currentTime.getTime() + timeOffset * 60 * 1000).toISOString().slice(0, 16);
      }
    },

    setReviewAnswerTime(event) {
      if (event?.target?.value) {
        const inputTime = new Date(event.target.value).toISOString();
        if (Array.isArray(this.editedReview.body.answers) && this.editedReview.body.answers[0] && this.editedReview.body.answers[0]?.time) {
          this.editedReview.body.answers[0].time = (new Date(inputTime).getTime() / 1000).toFixed();
        } else {
          if (!Array.isArray(this.editedReview.body.answers)) {
            this.editedReview.body.answers = [{}];
          }
          this.editedReview.body.answers[0].time = (new Date(inputTime).getTime() / 1000).toFixed();
        }
      } else {
        const inputTime = new Date().toISOString();
        if (Array.isArray(this.editedReview.body.answers) && this.editedReview.body.answers[0] && this.editedReview.body.answers[0]?.time) {
          this.editedReview.body.answers[0].time = (new Date(inputTime).getTime() / 1000).toFixed();
        } else {
          if (!Array.isArray(this.editedReview.body.answers)) {
            this.editedReview.body.answers = [{}];
          }
          this.editedReview.body.answers[0].time = (new Date(inputTime).getTime() / 1000).toFixed();
        }
      }
    },

    saveReviewChanges() {
      this.$emit('reviewChanged', this.editedReview);
    },
    addReviewAnswer() {
      this.editedReview.body.answers = [{ text: "", time: (Date.now() / 1000).toFixed(0) }]
      this.showAnswerField = true;
      this.$nextTick(() => {
        this.$refs.answerArea?.focus();
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.review-block__main-content {
  padding: 0 30px;
}

.raiting-star.in-review-block {
  width: 14px;
  height: 12.75px;
}

.raiting-star {
  flex-grow: 0;
  flex-shrink: 0;
  width: 42px;
  height: 38.25px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  &.filled {
    path {
      fill: #FFC828 !important;
    }
  }
}

.raiting-container.in-review-block {
  -moz-column-gap: 2px;
  column-gap: 2px;
  margin-bottom: 0;
}

.review-block {
  border-radius: 10px;
  border: 1px solid #c8cfd9;
  margin-bottom: 20px;
}

.raiting-container {
  position: relative;
  display: flex;
  -moz-column-gap: 7px;
  column-gap: 7px;
  margin-bottom: 8px;
  overflow: hidden;
}

.review-chain-section {
  position: relative;

  .files-uploader {
    p {
      margin-top: 0;
    }
  }
}

.review-block__answers-counter {
  display: flex;
  justify-content: flex-end;

  .default-btn {
    padding: 0;

    svg {
      display: inline-block;
      vertical-align: middle;
      margin-right: 5px;
      position: relative;
      top: -2px;
    }
  }
}

.review-block .form-control.custom-input {
  font-size: 14px;
}

.review-block__header .form-control.custom-input {
  padding: 0;
  border: none;
  height: 35px;

}

.review-block__text {
  margin-bottom: 20px;
}

.review-block__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #c8cfd9;
}

.review-block__status {
  position: relative;
  margin-top: -2px;
  margin-bottom: 0;
  color: #565656;
  font-size: 13px;
  line-height: normal;
}

.review-block__username {

  font-size: 16px;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 0;
}

.review-block__header-part-wrapper.left {
  margin-left: 12px;
}

.review-block__header-part-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-grow: 0;
  flex-shrink: 0;
}

.review-block__avatar span {
  line-height: 1;
}

.review-block__avatar img {
  width: 80%;
}

.review-block__header-part-wrapper.right {
  gap: 3px;
  margin-right: 27px;
}

.review-block__date-raiting-divider {
  width: 1px;
  height: 13px;
  background-color: #D9D9D9;
  margin: 0 3px;
}

.review-block__avatar {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #E9E9E9;
  overflow: hidden;
}

.review-block textarea .form-control.custom-input {
  height: 100px;
  font-size: 14px;
}


.review-block__answers-container {
  width: 90%;
  position: relative;
  margin-left: auto;
}
</style>